<template>
  <div
    class="
      flex justify-end
      print:hidden
    "
  >
    <label for="search-input" class="sr-only">
      {{ $t('search') }}
    </label>
    <input
      id="search-input"
      v-model="searchQuery"
      class="
        form-control w-full border border-gray-200 px-2
        lg:mr-8 lg:w-auto
      "
      name="q"
      type="search"
      :placeholder="$t('search')"
      @keyup.enter="submitSearch"
    />
  </div>
</template>

<script setup lang="ts">
// TODO: check with Kyle if there's a good vue3 example of search input

// Define a reactive reference for the search query
const searchQuery = ref<string>('')

// Get the current router instances
const router = useRouter()
const localePath = useLocalePath()

// Function to handle search submission
function submitSearch() {
  router.push({
    path: localePath({ name: 'SearchPage' }),
    query: { search: searchQuery.value },
  })
}
</script>
